export const checkOnlineConnectionLoader = async () => {
  // check online connection
  if ('onLine' in navigator && !navigator.onLine) {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw new Response('Offline', { status: 503, statusText: 'Offline' });
  }

  return null;
};
